export const initialState = {
    allUsers: undefined,
    coaching: undefined,
    downline: undefined,
    downlineCompetencies: undefined,
    errorMessage: '',
    googleAuthToken: '',
    preferences: undefined,
    redirectPath: null,
    showSuccess: false,
    stats: undefined,
    statsLastLoaded: null,
    statsLoading: false,
    user: undefined,
    working: true,
};
